import React from 'react';
import ReactDOM from 'react-dom';

import App from 'app/App/container';
import { CanvasProvider } from 'utils/store/connect';
import createCanvasStore from 'utils/store/createCanvasStore';

import './styles.scss';

/**
 * canvas app wrapped with providers
 * @returns {React.Component} the main canvas app
 */
const Root = () => (
  <CanvasProvider store={createCanvasStore()}>
    <App />
  </CanvasProvider>
);

ReactDOM.render(<Root />, document.getElementById('root'));
